(function (global) {
  'use strict';

  function parseQuantity(value) {
    var number = Number(value);
    return Number.isSafeInteger(number) && number > 0 ? number : null;
  }

  function sumCounts(options) {
    return options.reduce(function (total, option) { return total + option.count; }, 0);
  }

  function buildItems(watchId, watchQuantity, options) {
    var quantity = parseQuantity(watchQuantity);
    if (!/^\d+$/.test(String(watchId)) || !quantity) throw new Error('Select a valid watch and quantity.');
    if (sumCounts(options) !== quantity) throw new Error('Choose one bracelet for each watch.');
    var items = [{ id: Number(watchId), quantity: quantity }];
    options.forEach(function (option) {
      if (!option.count) return;
      if (!option.available || !/^\d+$/.test(String(option.id)) || !parseQuantity(option.count)) {
        throw new Error('A selected bracelet is unavailable.');
      }
      items.push({ id: Number(option.id), quantity: option.count });
    });
    if (items.length < 2) throw new Error('Choose at least one bracelet.');
    return items;
  }

  function giftsAreFree(cart, giftIds, offerToken) {
    if (!cart || !Array.isArray(cart.items)) return false;
    return giftIds.every(function (id) {
      var lines = cart.items.filter(function (item) {
        return String(item.variant_id || item.id) === String(id) &&
          (!offerToken || (item.properties && item.properties._zimor_offer === offerToken));
      });
      return lines.length > 0 && lines.every(function (item) {
        return Number(item.original_line_price) > 0 &&
          Number.isFinite(Number(item.final_line_price)) && Number(item.final_line_price) === 0;
      });
    });
  }

  var api = { parseQuantity: parseQuantity, sumCounts: sumCounts, buildItems: buildItems, giftsAreFree: giftsAreFree };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (global) global.ZimorGiftLogic = api;
})(typeof window !== 'undefined' ? window : null);
